import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { AppContainer } from './containers/AppContainer';
import createStore from './store/createStore';

const initialState =  {};
const store = createStore(initialState);
const mountNode = document.getElementById('root');

const render = () => {
  const routes = require('./routes/index').default(store);

  ReactDOM.render(
    <AppContainer store={ store } routes={ routes } />,
    mountNode
  );
};

render();



// WEBPACK FOOTER //
// ./src/index.tsx